import React from "react";
import { isReducedOrBoosted, ratingMultiplierLabel } from "../utils/rating-multiplier-label";

interface Props {
  ratingChange: number;
  multiplier: number | null | undefined;
}

const RatingChangeCell: React.FC<Props> = ({ ratingChange, multiplier }) => {
  const rounded = Math.round(ratingChange);
  const weighted = isReducedOrBoosted(multiplier);

  return (
    <td>
      <div style={{ color: rounded >= 0 ? "green" : "red" }}>
        {rounded >= 0 ? "+" : ""}
        {rounded}
      </div>
      <div
        style={{
          fontFamily: "monospace",
          fontSize: "0.8rem",
          fontWeight: weighted ? 600 : 400,
          color: weighted ? "#b45309" : "#888",
        }}
        title="Waga, z jaką ten mecz policzył się do rankingu"
      >
        {ratingMultiplierLabel(multiplier)}
      </div>
    </td>
  );
};

export default RatingChangeCell;
